import { gql } from 'apollo-boost';

export const ShippingOptionFragment = gql`
    fragment ShippingOptionFragment on ShippingOption {
        id
        name
    }
`;
